// Powell Towels - inject a black outline path behind each chevron's white path.
// This bakes the outline into the SVG geometry so CSS cascade / filters can't smother it.
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function addOutlinePath(svg) {
    var existing = svg.querySelector('path');
    if (!existing) return;
    // Already added?
    if (svg.querySelector('path[data-powell-outline]')) return;
    var outline = document.createElementNS(SVG_NS, 'path');
    outline.setAttribute('d', existing.getAttribute('d') || '');
    outline.setAttribute('fill', 'none');
    outline.setAttribute('stroke', '#000000');
    outline.setAttribute('stroke-width', '7');
    outline.setAttribute('stroke-linecap', existing.getAttribute('stroke-linecap') || 'round');
    outline.setAttribute('stroke-linejoin', existing.getAttribute('stroke-linejoin') || 'round');
    outline.setAttribute('data-powell-outline', '1');
    // Insert BEFORE existing path so it renders BEHIND
    svg.insertBefore(outline, existing);
  }

  function processChevrons() {
    document.querySelectorAll('.slideshow-control--previous svg, .slideshow-control--next svg').forEach(addOutlinePath);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processChevrons);
  } else {
    processChevrons();
  }

  // Re-run if the slideshow re-renders arrows (e.g., section re-render on variant change)
  var observer = new MutationObserver(function (mutations) {
    var needsRun = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('.slideshow-control--previous') || n.matches('.slideshow-control--next'))) { needsRun = true; break; }
        if (n.querySelector && n.querySelector('.slideshow-control--previous, .slideshow-control--next')) { needsRun = true; break; }
      }
      if (needsRun) break;
    }
    if (needsRun) processChevrons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
